import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: "100%",
    height: 55,
    borderTop: `1px solid ${theme.colors.magnetite}`,
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center",
    direction: theme.direction,
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 2,
    backgroundColor: theme.colors.white,
  },
  shadow: {
    boxShadow: theme.boxShadow?.primary,
  },
  rightSide: {
    width: 110,
    display: "flex",
    justifyContent: "flex-end",
  },
  leftSide: {
    width: 110,
  },
  center: {
    display: "flex",
    alignItems: "center",
    direction: "ltr",
  },
  icon: {
    marginRight: 5,
    height: 30,
    width: 25,
  },
  textBtn: {
    paddingLeft: "20px !important",
    paddingRight: "20px !important",
  },
  leftButton: {
    marginLeft: "14px !important",
  },
  rightButton: {
    marginRight: "14px !important",
  },
}));

export default useStyles;
